import { render, staticRenderFns } from "./MesaUserProfile.vue?vue&type=template&id=1d56239b&scoped=true"
import script from "./MesaUserProfile.vue?vue&type=script&lang=js"
export * from "./MesaUserProfile.vue?vue&type=script&lang=js"
import style0 from "./MesaUserProfile.vue?vue&type=style&index=0&id=1d56239b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56239b",
  null
  
)

export default component.exports